import React from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Card, CardContent, Typography, Button, Stack } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";

const ErrorCorrectionModule = () => {
  const navigationUrl = process.env.REACT_APP_PHP_URL;
  const userProfile = JSON.parse(localStorage.getItem("cred"));

  const token =
    "aHR0cHM6Ly93b3Jrc3BhY2UudGVhbWludGVydmFsLm5ldC9jYXJ0L2luZGV4";

  const handleRedirect = () => {
    if (navigationUrl && userProfile?.hashID) {
      window.open(
        `${navigationUrl}/login/auth/${userProfile.hashID}/${token}`,
        "_blank"
      );
    }
  };

  return (
    <GlobalWrapper title={"Cart Edit Module"}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          mt: 4,
        }}
      >
        <Card sx={{ width:'100%', width: "100%", borderRadius: 3,boxShadow:' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;' }}>
          <CardContent>
            <Stack spacing={2} alignItems="center">

              <Typography variant="body2" color="text.secondary" align="center">
                Click the button below to open the Cart Edit Module in a new tab.
              </Typography>

              <Button
                variant="contained"
                endIcon={<LaunchIcon />}
                onClick={handleRedirect}
                sx={{ mt: 1 }}
              >
                Open Cart Editor
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </GlobalWrapper>
  );
};

export default ErrorCorrectionModule;